<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-05 13:49:44
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-08-05 18:53:26
 * @Description:
-->
<template>
  <div class="sjz" style="width:100%">
    <div
      :class="index === steps.length - 1 ? 'sjz-item' : 'sjz-kuaikuai'"
      v-for="(item, index) in steps"
      :key="index"
    >
      <div class="sjz-item">
        <div
          :class="
            'sjz-icon ' +
              (index === activeIndex
                ? 'sjz-doing'
                : index > activeIndex
                ? 'sjz-done'
                : '')
          "
        >
          <i
            class="el-icon-check"
            style="width:40px;height:40px;"
            v-if="index < activeIndex"
          ></i>
          <span class="sjc-num sjc-do" v-else-if="index === activeIndex">{{
            index + 1
          }}</span>
          <span class="sjc-num" v-else-if="index > activeIndex">{{
            index + 1
          }}</span>
        </div>
        <div
          :class="
            'word-icon ' +
              (index === activeIndex
                ? 'word-do'
                : index > activeIndex
                ? 'word-undone'
                : '')
          "
        >
          {{ item.name }}
        </div>
      </div>
      <div
        :class="'sjz-line ' + (index >= activeIndex ? 'sjz-undone' : '')"
        v-if="index !== steps.length - 1"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sjz {
  float: unset;
  &::after {
    content: '';
    clear: both;
  }
}
</style>
